import React from "react";
import logo from "@/assets/billone-logo.png";

export function Logo({ size = 40, showText = false, className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img src={logo} alt="BillOne" style={{ width: size, height: size }} className="object-contain rounded-md" data-testid="billone-logo" />
      {showText && (
        <div className="leading-none">
          <div className="font-display font-extrabold text-[#1A2A5E] text-xl tracking-tight">
            Bill<span className="text-[#F4571E]">One</span>
          </div>
          <div className="text-[9px] tracking-[0.2em] text-slate-400 font-semibold mt-0.5">BILLING MADE SIMPLE</div>
        </div>
      )}
    </div>
  );
}
